import Icon from '../components/Icon.vue'

Icon.register({"stop-circle-o":{"width":1536,"height":1792,"paths":[{"d":"M768 128q209 0 385.5 103t279.5 279.5 103 385.5-103 385.5-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103zM768 1440q148 0 273-73t198-198 73-273-73-273-198-198-273-73-273 73-198 198-73 273 73 273 198 198 273 73zM480 1216q-14 0-23-9t-9-23v-576q0-14 9-23t23-9h576q14 0 23 9t9 23v576q0 14-9 23t-23 9h-576z"}]}})



// WEBPACK FOOTER //
// ./~/vue-awesome/icons/stop-circle-o.js